module.exports = QuickAdd;